import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  margin: 0 auto;
  max-width: 30rem;
  padding: 3rem 0 1rem;

  button {
    transition: filter 0.3s ease-in-out;

    &:hover,
    &:focus {
      filter: brightness(0.8);
    }
  }

  @media (min-width: 1024px) {
    padding-bottom: 0;
  }
`;
